/* PARALIA · sitio nuevo · inicio.
   - Contador de promoción: [data-pa-countdown data-end="ISO con huso" data-ended="hide|text"].
   - Producto destacado: [data-pa-feature] arma la variante con los radios de color y talla; el formulario
     (data-pa-product-form) lo agrega paralia.js con PA.add. */
(() => {
  if (window.PaHome) return;

  const pad = n => String(n).padStart(2, '0');

  /* ---------- contador ---------- */
  const countdowns = new Set();
  const tick = () => {
    const now = Date.now();
    countdowns.forEach(el => {
      if (!el.isConnected) { countdowns.delete(el); return; }
      const left = Math.max(0, Math.floor((el._paEnd - now) / 1000));
      const set = (u, v) => { const n = el.querySelector(`[data-unit="${u}"]`); if (n && n.textContent !== v) n.textContent = v; };
      set('d', pad(Math.floor(left / 86400)));
      set('h', pad(Math.floor((left % 86400) / 3600)));
      set('m', pad(Math.floor((left % 3600) / 60)));
      set('s', pad(left % 60));
      if (left === 0) {
        const end = el.querySelector('.pa-home-cd__end');
        if (el.dataset.ended === 'text' && end) {
          el.querySelector('.pa-home-cd__live').hidden = true;
          end.hidden = false;
        } else {
          el.hidden = true;
        }
        countdowns.delete(el);
      }
    });
  };
  let timer = null;
  const initCountdown = el => {
    const end = Date.parse(el.dataset.end);
    if (Number.isNaN(end)) return;
    el._paEnd = end;
    countdowns.add(el);
    tick();
    if (!timer) timer = setInterval(() => { tick(); if (!countdowns.size) { clearInterval(timer); timer = null; } }, 1000);
  };

  /* ---------- producto destacado ---------- */
  const initFeature = sec => {
    const form = sec.querySelector('form[data-pa-product-form]');
    if (!form || form._paReady) return;
    form._paReady = true;
    const read = sel => { try { return JSON.parse(sec.querySelector(sel).textContent); } catch (e) { return null; } };
    const variants = read('[data-pa-feat-variants]') || [];
    const label = read('[data-pa-feat-text]') || '';
    const soldOut = read('[data-pa-feat-soldout]') || '';
    const groups = [...sec.querySelectorAll('[data-pa-feat-option]')];
    const idInput = form.querySelector('[data-pa-feat-id]');
    const btn = form.querySelector('[data-pa-feat-btn]');
    const btnLabel = form.querySelector('[data-pa-feat-label]');
    const showPrice = btn && btn.dataset.showPrice === 'true';
    const badge = sec.querySelector('[data-pa-feat-badge]');
    const priceBox = sec.querySelector('[data-pa-feat-price]');
    const fmt = c => (window.PA ? PA.formatMoney(c) : `$${(c / 100).toFixed(2)}`);

    const selected = () => {
      const opts = [];
      groups.forEach(g => {
        const i = Number(g.dataset.paFeatOption);
        const c = g.querySelector('input:checked') || g.querySelector('input');
        opts[i] = c ? c.value : null;
      });
      return opts;
    };
    const match = opts => variants.find(v => v.options.every((o, i) => opts[i] == null || o === opts[i]));

    const setText = (el, text) => {
      if (!el) return;
      const nodes = [...el.childNodes].filter(n => n.nodeType === 3);
      if (nodes.length) nodes[nodes.length - 1].textContent = text; else el.append(text);
    };

    const update = () => {
      const opts = selected();
      const v = match(opts);
      /* disponibilidad de cada valor junto con lo demás elegido */
      groups.forEach(g => {
        const i = Number(g.dataset.paFeatOption);
        g.querySelectorAll('input').forEach(inp => {
          const test = opts.slice(); test[i] = inp.value;
          const ok = variants.some(x => x.available && x.options.every((o, k) => test[k] == null || o === test[k]));
          const lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) { btn.disabled = true; setText(btnLabel, soldOut); return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? (showPrice ? `${label} · ${fmt(v.price)}` : label) : soldOut;
      if (priceBox) {
        setText(priceBox.querySelector('.pa-price__sale, .pa-price__regular'), fmt(v.price));
        setText(priceBox.querySelector('.pa-price__compare'), v.compare > v.price ? fmt(v.compare) : '');
      }
      if (badge) {
        const pct = v.compare > v.price ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
        badge.hidden = pct === 0;
        badge.textContent = `−${pct} %`;
      }
    };
    sec.addEventListener('change', e => { if (e.target.matches('[data-pa-feat-option] input')) update(); });
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-pa-countdown]').forEach(initCountdown);
    root.querySelectorAll('[data-pa-feature]').forEach(initFeature);
  };

  window.PaHome = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
